<h2 mat-dialog-title>Edit Organization</h2>

<mat-dialog-content>
  <form [formGroup]="organizationForm">
    <mat-form-field appearance="outline" style="width: 100%;" class="display-name-field">
      <mat-label>Display Name</mat-label>
      <input matInput formControlName="displayName" />
      <mat-error *ngIf="organizationForm.get('displayName')?.hasError('required')">
        Display name is required
      </mat-error>
    </mat-form-field>

    <div class="color-row">
      <mat-form-field appearance="outline">
        <mat-label>Primary Color</mat-label>
        <input matInput formControlName="primaryColor" />
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Secondary Color</mat-label>
        <input matInput formControlName="secondaryColor" />
      </mat-form-field>
    </div>

    <mat-form-field appearance="outline" style="width: 100%;">
      <mat-label>Logo URL</mat-label>
      <input matInput formControlName="logoUrl" />
      <mat-error *ngIf="organizationForm.get('logoUrl')?.hasError('required')">
        Logo URL is required
      </mat-error>
    </mat-form-field>

    <mat-form-field appearance="outline" style="width: 100%;">
      <mat-label>Mail Logo URL (optional)</mat-label>
      <input matInput formControlName="mailLogoUrl" />
    </mat-form-field>

    <mat-form-field appearance="outline" style="width: 100%;">
      <mat-label>Billing Payment Type</mat-label>
      <mat-select formControlName="billingPaymentType">
        <mat-option value="CARD">Card</mat-option>
        <mat-option value="INVOICE">Invoice</mat-option>
      </mat-select>
    </mat-form-field>

    <div class="admin-email-list settings-toggle settings-toggle-first">
      <mat-checkbox color="primary" formControlName="autoApproveNewUsers">
        Auto-approve new users for this organization
      </mat-checkbox>
    </div>

    <div class="admin-email-list settings-toggle settings-toggle-last">
      <mat-checkbox color="primary" formControlName="billingPaymentExempt">
        Team is exempt from payments
      </mat-checkbox>
    </div>

    <div class="admin-email-list" *ngIf="existingAdmins.length > 0">
      <div class="admin-email-row" *ngFor="let admin of existingAdmins">
        <mat-form-field appearance="outline" class="admin-email-input full-width">
          <mat-label>Existing Admin</mat-label>
          <input matInput [value]="admin.email" disabled />
        </mat-form-field>
        <mat-checkbox
          class="billing-owner-checkbox"
          color="primary"
          [checked]="isBillingOwnerEmail(admin.email)"
          (change)="setBillingOwnerEmail(admin.email)">
          Billing owner
        </mat-checkbox>
        <div class="admin-email-actions">
          <button
            type="button"
            mat-icon-button
            disabled
            aria-hidden="true"
            class="admin-email-action-placeholder">
            <mat-icon>add</mat-icon>
          </button>
        </div>
      </div>
    </div>

    <div class="admin-email-list" formArrayName="adminEmails">
      <div class="admin-email-row" *ngFor="let control of adminEmails.controls; let i = index">
        <mat-form-field appearance="outline" class="admin-email-input full-width">
          <mat-label>New Admin Invite {{ i + 1 }}</mat-label>
          <input matInput type="email" [formControlName]="i" />
          <mat-error *ngIf="control.hasError('email')">Enter a valid email</mat-error>
        </mat-form-field>
        <mat-checkbox
          class="billing-owner-checkbox"
          color="primary"
          [checked]="isBillingOwnerEmail(control.value || '')"
          (change)="setBillingOwnerEmail(control.value || '')">
          Billing owner
        </mat-checkbox>
        <div class="admin-email-actions">
          <button
            type="button"
            mat-icon-button
            color="warn"
            (click)="removeAdminEmailField(i)"
            *ngIf="adminEmails.length > 1">
            <mat-icon>remove</mat-icon>
          </button>
          <button
            type="button"
            mat-icon-button
            color="primary"
            (click)="addAdminEmailField()"
            [disabled]="adminEmails.length >= maxAdminEmails"
            [matTooltip]="'Add another admin email (max ' + maxAdminEmails + ')'">
            <mat-icon>add</mat-icon>
          </button>
        </div>
      </div>
    </div>

    <div class="email-list-error" *ngIf="emailListError">{{ emailListError }}</div>
  </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="onCancel()">Cancel</button>
  <button mat-raised-button color="primary" (click)="onSubmit()" [disabled]="organizationForm.invalid">
    Save
  </button>
</mat-dialog-actions>
